function runPo2go() {
  const storeConfig = {
    punchout_only: 0,
    allow_zero_value_cart: false,
    transfer_label: "Transfer Cart",
    custom_style: 'body.punchout .nonpunchoutcheckout {display:none} .transfer {display:block} .shopify-payment-button {display:none} .social-sharing {display:none} .site-header--text-links {display:none} button[name=\"transfer_cart\"]:nth-child(2) {display:none}', 
    checkout_selector: "button[name=\"checkout\"]",
    transfer_selector: 'button[name="transfer_items"]',
    transfer_btn_html: '<button type="submit" name="transfer_items" class="cart__checkout-button button" onClick="POSession.extension.transferCart(); return false;" >Transfer Cart</button>',
    return_selector: "div[class=\"topbar__inner\"]",
    return_btn_html:'<button type="submit" name="close_punchout" class="btn return_btn" onClick="POSession.cancel();">Close PunchOut</button>',
  };

  window.POExt = new Po2go_Shopify(storeConfig);
  window.POSession = new Po2go({
    account: "",
    punchout_only: storeConfig.punchout_only,
    extension: window.POExt,
  });

  window.POSession.init();
  window.POSession.extension.setupPage();
  window.POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}

window.runPo2go = runPo2go;